import { Validator } from 'vee-validate'

Validator.extend('alpha_num_space', {
  getMessage: field => {
    return `Field ${field} does not contain the appropriate pattern`
  },
  // Alpha-numeric + space
  validate: (value) => {
    return /^[\w\-\s]+$/.test(value)
  }
})



// WEBPACK FOOTER //
// ./src/helpers/rules-alphanumerics.js